import React, { useState, useEffect } from "react"
import { Modal } from "reactstrap"
import Select from "react-select"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast, ToastContainer } from "react-toastify"
import axios from "axios"

let selectedUserId = []
export default function LeadSequenceModal(props) {
  
  
  const [allUsers, setAllUsers] = useState([])
  const [selectedAllUsers, setSelectedAllUsers] = useState([])
  

  const getAllUsers = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/user?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        setAllUsers(res.data.data.data)
      })
      .catch(err => {})
  }
  const getLeadSequence = async () => {
    try {
        const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem("company_name")}/lead-sequences`,
        {
            headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
            },
        }
        )

        const data = res?.data?.data || []

        // 🔥 convert to react-select format
        const selected = data.map(item => ({
        value: item.user_id,
        label: item.user_name,
        }))

        setSelectedAllUsers(selected)

    } catch (err) {
        console.log("Sequence fetch error", err)
    }
    }
  useEffect(() => {
      getAllUsers()
      getLeadSequence()
      if (props.fetch !== undefined) {
      selectedUserId = []
      props.fetch.assigneename?.map(item => {
        dValues.push({
          value: item.id,
          label: item.name,
        })
        selectedUserId.push(item.id)
      })
    }
    }, [])
    const options = []

  if (allUsers !== undefined) {
    allUsers.map(item => {
      options.push({
        value: item.id,
        label: item.name,
      })
    })
  }
  const getSelectedId = e => {
  setSelectedAllUsers(e || [])
}
  const dValues = []
  const handleSave = async () => {
  console.log("CLICKED ✅")

  try {
    
    const payload = selectedAllUsers.map((user, index) => ({
    user_id: user.value,
    sequence_order: index + 1,
    is_pointer: index === 0 ? 1 : 0,
    }))

    console.log("Payload:", payload)

    const url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem("company_name")}/lead-sequences`

    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${getCurrentUser()?.token || ""}`,
      },
    }

    let res

    
    res = await axios.post(url, { users: payload }, config)
    

     props.setnew_leadsequence(false)
     toast.success(res.data.message, {
                   position: "top-center",
                   autoClose: 5000,
                   hideProgressBar: false,
                   closeOnClick: true,
                   pauseOnHover: true,
                   draggable: true,
                   progress: undefined,
                 })
                 props.getWebApi()

  } catch (err) {
    console.log(err);
    toast.error(err.data.message, {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
  }
}

  return (
    <Modal isOpen={props.nwemodal_leadsequence} centered={true}>
       <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
             Lead Sequence
            </h5>
            <button
              type="button"
              className="cross__btn"
              onClick={() => props.setnew_leadsequence(false)}
              aria-hidden="true"
            >
              &times;
            </button>
          </div>  
      <div className="p-3">
        

        <div className="form-group mb-3">
              <label>Select User To Assign</label>
              <Select
                isMulti
                isClearable={true}
                name="assignees"
                options={options}
                value={selectedAllUsers}   // ✅ IMPORTANT
                onChange={getSelectedId}
                />
            </div>

        <button className="btn btn-primary mt-3" onClick={handleSave}>
          Save Sequence
        </button>
      </div>
    </Modal>
  )
}